import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import { DialogContent } from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { Proxy, withArtifex } from "core";
import ClientHelper from "core/ClientHelper";
import MenuAuthorityRightHelper from "core/MenuAuthorityRightHelper";
import PropTypes from "prop-types";
import React, { Component } from "react";
import ButtonToolbar from "views/Components/ButtonToolbar.jsx";
import {
   GenericAlert,
   GenericCheckInput,
   GenericDialog,
   GenericDialogActions,
   GenericExpansionPanel,
   GenericGrid,
   GenericLabel,
   GenericSelectInput,
   GenericTextInput,
} from "views/Components/Generic";
import LoadingComponent from "views/Components/LoadingComponent";
import { GetColumns } from "views/PSP/Merchant/MerchantColumns";

class MerchantList extends Component {
   constructor(props) {
      super(props);

      this.isClient = ClientHelper.IsClient();
      this.isBackoffice = ClientHelper.IsBackOffice();
      this.hasPspClientFlag = ClientHelper.HasPspClientFlag();

      this.initialModel = {
         Id: 0,
         UniqueClientId: this.isClient ? ClientHelper.GetClientRowId() : -1,
      };

      this.state = {
         alert: null,
         model: { ...this.initialModel },
         rowModel: { ...this.initialModel },
         list: [],
         isLoading: false,
         gridButtonRightDetail: [],
         openDialog: false,
         selectedValidation: null,
      };

      this.trxTable = React.createRef();
      this.MenuAuthorityRightHelper = new MenuAuthorityRightHelper();

      this.parameterUniqueClientId = {
         UniqueClientId: this.isClient ? ClientHelper.GetClientId() : undefined,
      };

      this.parameterClient = {};

      this.renderItemUniqueClient = {};

      const DefinitionColumns = GetColumns(this.props, this.state, this.handleOpenDialog);

      this.ColumnsData = [...DefinitionColumns];
   }

   componentDidMount() {
      const { setAppLeftTitle, setAppCenterTitle } = this.props;

      if (setAppLeftTitle) setAppLeftTitle("Merchant List");
      if (setAppCenterTitle) setAppCenterTitle("PSP RPAA");
   }

   HandleChange = (name, newValue, data) => {
      const model = { ...this.state.model };
      model[name] = newValue;
      this.setState({ model });
   };

   HandleRowChange = (name, newValue, data) => {
      const rowModel = { ...this.state.rowModel };
      rowModel["User"][name] = newValue;
      this.setState({ rowModel });
   };

   ValueChanged = (name, value) => {
      this.setState({ [name]: value });
   };

   HandleSearch = () => {
      const { model } = { ...this.state };
      this.setState((state) => ({ trxGridToken: !state.trxGridToken, loadingCompleted: true, model, alert: null }));
   };

   HandleClear = () => {
      this.setState({ model: { ...this.initialModel } });
   };

   ErrorCallback = (error) => {
      this.setState({ isLoading: false });
      this.ShowMessage("error", "Error", "An error occurred during the api visit" + error);
   };

   GetModel = () => {
      return this.state.model;
   };

   GetClientParameter = () => {
      this.parameterClient.UniqueClientId = this.state.model.UniqueClientId;
      return this.parameterClient;
   };

   RenderItemUniqueClient = (d) => {
      this.renderItemUniqueClient = `${d.UniqueClientId} - ${d.Name}`;
      return this.renderItemUniqueClient;
   };

   Validate = () => {
      const { model } = this.state;

      if (!model.UniqueClientId) {
         this.ShowMessage("warning", "Client not selected", "Select Client to continue.");
         return false;
      }

      return true;
   };

   ShowMessage = (type, title, message) => {
      this.setState({
         alert: (
            <GenericAlert
               Title={title}
               Message={message}
               Type={type}
               OnConfirm={() => this.setState({ alert: null })}
            />
         ),
      });
   };

   ShowConfirmMessage = (type, title, message, onConfirm, showCancel = true) => {
      this.setState({
         alert: (
            <GenericAlert
               Title={title}
               Message={message}
               Type={type}
               ShowCancel={showCancel}
               OnCancel={() => this.setState({ alert: null })}
               OnConfirm={onConfirm}
            />
         ),
      });
   };

   hideAlert = () => {
      this.setState({ isLoading: false, autoDepositInsertDialogOpen: false, isConfirmDeleteDialogOpen: false });
   };

   handleOpenDialog = (type, row, value) => {
      if (!value || value === "N/A") return;
      this.setState({ openDialog: true, selectedValidation: { type, row, value } });
   };

   handleCloseDialog = () => {
      this.setState({ openDialog: false, selectedValidation: null });
   };

   handleValidationAction = (action) => {
      const { selectedValidation } = this.state;
      if (!selectedValidation) return;

      const request = {
         MerchantNumber: selectedValidation.row.MerchantNumber,
         IdentifierType: selectedValidation.type,
         ValidationAction: action,
      };

      this.setState({ isLoading: true });

      Proxy.POST("/bankapi/v1.0/PspMerchant/ValidationMerchant", request, (resp) => {
         this.setState({ isLoading: false });
         if (!resp.IsSucceeded || resp.ErrorCode !== "0") {
            this.ShowMessage("error", "Validation Failed", resp.ErrorDescription || "Error");
            return;
         }
         this.ShowMessage("success", "Validation", "Action completed successfully.");
         this.handleCloseDialog();

         this.setState((state) => ({ trxGridToken: !state.trxGridToken }));
      });
   };

   render() {
      const { Disabled } = this.props;
      const { alert, model, isLoading, ReadOnly } = this.state;

      return (
         <>
            {alert}
            <LoadingComponent Show={isLoading} />

            {(this.isBackoffice || this.hasPspClientFlag) && (
               <ButtonToolbar
                  ButtonList={[
                     { Code: "Search", OnClick: this.HandleSearch, Disabled: ReadOnly || Disabled },
                     { Code: "Clear", OnClick: this.HandleClear, Disabled: Disabled },
                  ]}
                  menuId={this.props.menuId}
                  ApprovalData={this.props.ApprovalData}
                  After={this.props.After}
               />
            )}

            <GridContainer>
               <GridItem xs={12}>
                  {(this.isBackoffice || this.hasPspClientFlag) && (
                     <Card className="no-radius">
                        <CardBody>
                           <GenericExpansionPanel Title="Filter Panel">
                              <GridContainer>
                                 <GridItem xs={4}>
                                    <GenericSelectInput
                                       Name="UniqueClientId"
                                       LabelText="Client"
                                       Method="POST"
                                       Url="/bankapi/v1.0/PspMerchant/GetAllPspClients"
                                       Parameter={this.parameterUniqueClientId}
                                       DataRoot="Item"
                                       KeyValueMember="Id"
                                       RenderItem={this.RenderItemUniqueClient}
                                       Value={model.UniqueClientId}
                                       ValueChanged={this.HandleChange}
                                       CanClear
                                       All
                                       Disabled={this.isClient}
                                       DefaultIndex={this.isClient ? 0 : -1}
                                    />
                                 </GridItem>

                                 <GridItem xs={4}>
                                    <GenericTextInput
                                       Name="MerchantNumber"
                                       LabelText="Merchant Number"
                                       Value={model.MerchantNumber}
                                       ValueChanged={this.HandleChange}
                                    />
                                 </GridItem>

                                 <GridItem xs={2}>
                                    <GenericLabel Text="Restricted Merchant" />
                                    <GenericCheckInput
                                       Disabled={this.isClient}
                                       Value={model.RestrictedMerchant}
                                       ValueChanged={() =>
                                          this.HandleChange("RestrictedMerchant", !model["RestrictedMerchant"])
                                       }
                                    />
                                 </GridItem>
                              </GridContainer>
                           </GenericExpansionPanel>
                        </CardBody>
                     </Card>
                  )}

                  <Card className="no-radius">
                     <CardBody>
                        <GenericExpansionPanel Title="Merchant List">
                           <GridContainer>
                              <GridItem xs={12}>
                                 <GenericGrid
                                    key={"trxGrid" + this.state.trxGridToken}
                                    ref={this.trxTable}
                                    PageSize={20}
                                    ShowPagination={true}
                                    Columns={this.ColumnsData}
                                    DocumentTitle="Merchant List"
                                    ServerSide
                                    LoadAtStartup={this.state.loadingCompleted}
                                    ValidateRequest={this.Validate}
                                    PrepareRequest={this.GetModel}
                                    RequestUrl="/bankapi/v1.0/PspMerchant/GetAllMerchant"
                                    RequestMethod="POST"
                                    IsSorted={false}
                                 />
                              </GridItem>
                           </GridContainer>
                        </GenericExpansionPanel>
                     </CardBody>
                  </Card>
               </GridItem>
            </GridContainer>
            <GenericDialog open={this.state.openDialog} maxWidth="sm" onBackdropClick={this.handleCloseDialog}>
               <DialogContent>
                  <h4 style={{ color: "black", textAlign: "center" }}>
                     <b>{this.state.selectedValidation?.type} Validation</b>
                  </h4>
                  <br />
                  <div style={{ textAlign: "center" }}>
                     <>
                        <Button size="sm" color="warning" onClick={() => this.handleValidationAction("Resend")}>
                           Resend
                        </Button>
                        <Button size="sm" color="success" onClick={() => this.handleValidationAction("Verified")}>
                           Verified
                        </Button>
                        <Button size="sm" color="danger" onClick={() => this.handleValidationAction("Failed")}>
                           Failed
                        </Button>
                     </>
                  </div>
               </DialogContent>
               <GenericDialogActions>
                  <Button size="sm" onClick={this.handleCloseDialog}>
                     Close
                  </Button>
               </GenericDialogActions>
            </GenericDialog>
         </>
      );
   }
}

MerchantList.propTypes = {
   classes: PropTypes.object.isRequired,
   setAppLeftTitle: PropTypes.func,
   setAppCenterTitle: PropTypes.func,
   Disabled: PropTypes.bool,
};

export default withArtifex(MerchantList, {});